@let _message = message();
@let comments = _message.task_comments;

<section [attr.data-message-id]="_message.id" class="partner-portal-message flex items-start gap-2 pt-2 px-4 mb-4 pb-[6px] text-lendio-warm-gray-900">
    <!-- Initals monogram -->
    <div class="flex-shrink-0">
        <app-initials-monogram
            [user]="_message.creator_user"
            [index]="index()"
        />
    </div>

    <div class="flex flex-col w-full">
        <div class="message-header flex items-center gap-2 mt-0.5">
            <!-- Name -->
            <span class="label-medium">
                {{ userFullName(_message.creator_user) }}
            </span>
            <!-- Date -->
            <span class="body-small text-lendio-warm-gray-400">
                {{relativeDate(_message.createdTimestamp, true)}}
            </span>
        </div>

        <!-- Message -->
        <div class="message-content mt-[5px]">
            <span class="body-medium" [innerHTML]="_message.description"></span>
        </div>

        <div class="message-footer flex items-center gap-2 mt-[11px] min-h-6">
            <!-- Reply count -->
            <span class="label-small">
                {{ comments.length }}
                {{ comments.length === 1 ? "reply" : "replies" }}
            </span>
            @if (_message.task_comments.length) {
                <span class="body-small text-lendio-warm-gray-400 mt-[-2px]">
                    Last reply {{relativeDate(_message.task_comments.at(-1)?.createdTimestamp)}}
                </span>
            }

            <!-- In progress/Complete -->
            <!-- TODO: This will be completed in Milestone 2 of Messages Usability Enhancements project: -->
            <!-- https://docs.google.com/document/d/14X9IGovYf3QAEndZxq7Z56_AjrHe3NYlxSZZ09MZWCk/edit?tab=t.0 -->
            <!-- Only show for SBA Specialist messages -->
            <!-- @if (_message.fromRole === FromRole.FundingManager) {
                <mat-chip class="lendio-chip-label needs-review">
                    {{ _message.completed ? "Completed" : "In Progress" }}
                </mat-chip>
            } -->

            <!-- Icon buttons -->
            <div class="message-small-icons flex items-center gap-1 ml-auto lendio-density-2">
                <!-- TODO: This will be completed in Milestone 2 of Messages Usability Enhancements project: -->
                <!-- https://docs.google.com/document/d/14X9IGovYf3QAEndZxq7Z56_AjrHe3NYlxSZZ09MZWCk/edit?tab=t.0 -->
                <!-- <mat-icon>check_small</mat-icon> -->
                <button
                    mat-icon-button
                    matTooltip="Reply"
                    (click)="replyInputIsVisible.set(!replyInputIsVisible())">
                    <mat-icon class="material-icons-outlined">add_comment</mat-icon>
                </button>
                @if (comments.length) {
                    <button
                        mat-icon-button
                        [matTooltip]="repliesAreVisible() ? 'Show less' : 'Show more'"
                        (click)="repliesAreVisible.set(!repliesAreVisible())">
                        @if (repliesAreVisible()) {
                            <mat-icon>keyboard_arrow_up</mat-icon>
                        } @else {
                            <mat-icon>keyboard_arrow_down</mat-icon>
                        }
                    </button>
                }
            </div>
        </div>

    </div>
</section>

<!-- Replies -->
@if (repliesAreVisible()) {
    <section class="message-replies -mt-2">
         @for (comment of comments; track comment.id) {
             <app-message-reply [reply]="comment" />
         }
    </section>
}

<!-- Add reply -->
@if (replyInputIsVisible()) {
    <app-add-message-reply
      [dealId]="dealId()"
      [messageId]="_message.id"
      (replyAdded)="handleReplyAdded()" />
}
